var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 3.07812H4.92188V1.37501C4.92188 0.866215 4.50879 0.453125 4.00001 0.453125C3.49121 0.453125 3.07812 0.866215 3.07812 1.37501L3.07813 3.07812L1.37501 3.07812C0.866215 3.07812 0.453125 3.49121 0.453125 4.00001C0.453125 4.50879 0.866215 4.92188 1.37501 4.92188H3.07813V6.625C3.07813 7.13379 3.49121 7.54688 4.00001 7.54688C4.50879 7.54688 4.92188 7.13379 4.92188 6.625V4.92188H6.625C7.13379 4.92188 7.54688 4.50879 7.54688 4.00001C7.54688 3.49121 7.13379 3.07812 6.625 3.07812Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.56e8f0559644c1fe43795e55cb8e8c82.svg";
export { ForwardRef as ReactComponent };